var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4540_2585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3459 15.5059H14.6529V22.2389H7.9209V24.9319H14.6539V31.6649H17.3469V24.9319H24.0799V22.2389H17.3469L17.3459 15.5059Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.609 10.8851L20.943 0.384062C20.6913 0.13725 20.3526 -0.000673392 20 6.19779e-05H2.667C1.96547 -0.0047337 1.29068 0.268951 0.790691 0.761068C0.2907 1.25318 0.00633965 1.92354 0 2.62506V39.3751C0.00660298 40.0765 0.291048 40.7467 0.790981 41.2388C1.29091 41.7308 1.96555 42.0046 2.667 42.0001H29.333C30.0345 42.0046 30.7091 41.7308 31.209 41.2388C31.709 40.7467 31.9934 40.0765 32 39.3751V11.8121C31.9998 11.6391 31.9651 11.468 31.898 11.3087C31.8309 11.1493 31.7326 11.005 31.609 10.8841V10.8851ZM21.333 4.48506L27.448 10.5001H21.333V4.48506ZM29.333 39.3791H2.667V2.62506H18.667V10.5001C18.6736 11.2015 18.958 11.8717 19.458 12.3638C19.9579 12.8558 20.6326 13.1296 21.334 13.1251H29.334V39.3751L29.333 39.3791Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4540_2585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/upload.icon.3a8a5d29b41d21edda777f4e8d2a67af.svg";
export { ForwardRef as ReactComponent };